import _Input from "@alifd/next/es/input";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["nextTablePrefix", "value", "onChange", "rules", "name"];
import React from "react";
import BaseTableField from "./baseTableField";
var InputField = /*#__PURE__*/function (_BaseTableField) {
  _inheritsLoose(InputField, _BaseTableField);
  function InputField() {
    return _BaseTableField.apply(this, arguments) || this;
  }
  var _proto = InputField.prototype;
  _proto.renderField = function renderField() {
    var field = this.field;
    var _this$props = this.props,
      nextTablePrefix = _this$props.nextTablePrefix,
      value = _this$props.value,
      onChange = _this$props.onChange,
      rules = _this$props.rules,
      name = _this$props.name,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(_Input, _extends({
      className: nextTablePrefix + "input"
    }, field.init(name, {
      rules: rules
    }, rest)));
  };
  return InputField;
}(BaseTableField);
export { InputField as default };